import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import { BASE_URL } from '../chartConstants';

const sdk = new ChartsEmbedSDK({
  baseUrl: BASE_URL,
});

const ChartEmbed = ({ chartId, height, filter }) => {
  const containerRef = useRef(null);
  const chartRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;
    const chart = sdk.createChart({ chartId, height, autoRefresh: false, theme: 'dark' });
    chartRef.current = chart;
    chart
      .render(containerRef.current)
      .then(() => setReady(true))
      .catch(() => {});
    return () => {
      setReady(false);
      chartRef.current = null;
    };
  }, [chartId]);

  useEffect(() => {
    if (!ready || !chartRef.current) return;
    chartRef.current.setFilter(filter || {}).catch(() => {});
  }, [ready, JSON.stringify(filter, (_, v) => (v instanceof Date ? v.toISOString() : v))]);

  return <div ref={containerRef} style={{ height, width: '100%' }} />;
};

ChartEmbed.propTypes = {
  chartId: PropTypes.string.isRequired,
  height: PropTypes.string,
  filter: PropTypes.object,
};

ChartEmbed.defaultProps = {
  height: '300px',
  filter: {},
};

export default ChartEmbed;
